
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: Storytelling
* Copyright IBM Corp. 2017, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'story': 'Priča',
	'noDashboardFound': 'Priča se ne može dohvatiti. Možda više ne postoji ili nemate dovoljne povlastice da biste ju vidjeli.',
	'noDashboardCapability': 'Nemate mogućnost korištenja priča',
	'noDashboardPermision': 'Nemate dovoljne povlastice za gledanje ove priče',
	'defaultName': 'Nova priča',
	'storyProperties': 'Svojstva priče',
	'createAvDataStoryLabel': 'Priča',
	'createAvSlideShowLabel': 'Prikaz slajdova',
	'createAvPanAndZoomLabel': 'Putovanje s vodičem',
	'dashboard_save_success': 'Vaša priča je spremljena.',
	'cmEmptySelection': 'Priča je izbrisana. Pokušajte spremiti novu priču.',
	'createStoryTitle': 'Kreiraj priču',
	'transitionStyleTitle': 'Stil prijelaza',
	'createButton': 'Kreiraj',
	'cancelButton': 'Opoziv',
	'dashboardResetTitle': 'Reset priče',
	'dashboardResetMessage': 'jeste li sigurni da želite resetirati sve promjene primijenjene na ovu priču?',
	'dashboardResetToast': 'Vaša priča je resetirana.',
	'filter_drag_and_drop_all_tabs': 'Povucite i ispustite podatke ovdje za filtriranje svih scena.',
	'filter_drag_and_drop_current_tab': 'Povucite i ispustite podatke ovdje za filtriranje ove scene.',
	'filterIconLabel_Global': 'Sve scene',
	'filterIconLabel_Tab': 'Ova scena',
	'filterIconTooltip_Global': 'Sve scene',
	'filterIconTooltip_Tab': 'Ova scena',
	'filterOverflowMenu_Global': 'Dodatni izbornik svih scena',
	'filterOverflowMenu_Tab': 'Dodatni izbornik ove scena',
	'renameScene': 'Preimenuj scenu',
	'duplicateScene': 'Dupliciraj scenu',
	'deleteScene': 'Izbriši scenu',
	'editTimelineHighlight': 'Uredi isticanje',
	'deleteTimelineHighlight': 'Izbriši isticanje',
	'filter_includesAll': 'Uključi sve',
	'timeline_highlight_moved_to': 'Isticanje vremenske skale %{id} pomaknuto na %{time}',
	'filter_tooltip': '[%{title}] - %{description}',
	'selectLabel': 'Izbor',
	'newDefaultStoryName': 'Priča: %{modelName}',
	'exportLabel': 'Spremi',
	'exportAsLabel': 'Spremi kao:',
	'exportDialogTitle': 'Spremi priču',
	'exportDialogFooter': 'Gumbi Spremi i Opoziv',
	'loadAfterExportLabel': 'Otvori priču nakon spremanja',
	'selectTemplateLabel': 'Izbor predloška',
	'outOfBoundsWarningMessage': 'Neki grafički elementi kontrolne ploče nalaze se izvan mreže pa je moguće da se neće ispravno prikazati nakon eksporta.',
	'emptyExploreCardsWarningMessage': 'Prazne kartice su izbrisane tijekom spremanja u obliku priče.',
	'dashboard_export_success': 'Vaša kontrolna ploča je uspješno spremljena kao priča.',
	'explore_export_success': 'Vaše istraživanje je uspješno spremljeno kao priča.',
	'toastUpgradeDone': 'Vaša priča je nadograđena. Spremite sad da zadržite optimalne performanse.',
	'navigationMarker': 'Marker navigacije',
	'navigateMarkers': 'Navigacija markerima',
	'navNextMarker': 'Sljedeći marker',
	'navPrevMarker': 'Prethodni marker',
	'navPrevMarkerAbbreviated': 'Prethodni marker',
	'timelineSettingsButton': 'Opcije izvođenja',
	'autoPlay': 'Izvedi sve scene',
	'loop': 'Petlja',
	'refreshData': 'Osvježi na početku',
	'slideshowLabel': 'Prikaz slajdova',
	'panAndZoomLabel': 'Putovanje s vodičem',
	'slideShowLayoutLabel': 'Prikaz u obliku slajdova',
	'panAndZoomLayoutLabel': 'Prikaz putovanja s vodičem',
	'panAndZoomLayoutFooter': 'Prikaz putovanja s vodičem sastoji se od zbirke scena na jednom platnu. Kad izvodite ovaj tip priče, prezentacija zumira i pomiče prozor na svaku pojedinu scenu sekvencijalnim redoslijedom. Razlikuje se od prikaza slajdova jer se tamo svaka scena prikazuje na novom platnu. Prikaz putovanja s vodičem od tri scene povezane crtama omogućuje kreiranje vodoravnog niza scena. To je korisno kad prikazujete vremensku skalu događaja.',
	'PanAndZoomLayout1': '5 scena svrstano u pravokutni oblik',
	'PanAndZoomLayout2': '4 scene svrstane u obliku stepenica, koje se penju s lijeva na desno',
	'PanAndZoomLayout3': '6 scena svrstano u pravokutni oblik',
	'PanAndZoomLayout4': '7 scena svrstano u pravokutni oblik, 6 malih scena na vrhu i 1 velika scena na dnu',
	'PanAndZoomLayout5': '3 scene svrstane tako da su 2 male scene na vrhu i 1 velika scena na dnu',
	'PanAndZoomLayout6': 'Niz od 4 scene svrstan vodoravno',
	'pageSelectWarning': 'Molim, izaberite scenu.',
	'noSceneTransitionLabel': 'Nijedno',
	'sceneTransitionPropertyLabel': 'Prijelaz scene',
	'animatedPathSceneTransitionLabel': 'Animirana staza',
	'sweepSceneTransitionLabel': 'Pometi',
	'storyTypeLabel': 'Tip priče',
	'layoutLabel': 'Izgled',
	'tabName_animation': 'Animacija',
	'propAniAnimation': 'Animacija',
	'propAniTypeEntrance': 'Ulazna animacija',
	'propAniDirectionIn': 'Smjer ulaza',
	'propAniTypeExit': 'Izlazna animacija',
	'propAniDirectionOut': 'Smjer izlaza',
	'propAniDirection': 'Smjer',
	'propAniEntrance': 'Ulaz',
	'propAniTypeEntranceSlideIn': 'Ulazak',
	'propAniTypeEntranceFadeIn': 'Pojavi se',
	'propAniTypeEntrancePivotIn': 'Zakreni u',
	'propAniTypeEntranceScaleIn': 'Uvećaj',
	'propAniTypeEntranceShrinkIn': 'Umanji',
	'propAniDirectionInLeft': 'Od lijeve strane',
	'propAniDirectionInRight': 'Od desne strane',
	'propAniDirectionInTop': 'Od vrha',
	'propAniDirectionInBottom': 'Od dna',
	'propAniExit': 'Izlaz',
	'propAniTypeExitSlideIn': 'Izlazak',
	'propAniTypeExitFadeIn': 'Iščezni',
	'propAniTypeExitPivotOut': 'Zakreni van',
	'propAniTypeExitScaleIn': 'Umanji',
	'propAniTypeExitExpandOut': 'Proširi',
	'propAniDirectionOutLeft': 'Na lijevo',
	'propAniDirectionOutRight': 'Na desno',
	'propAniDirectionOutTop': 'Na vrh',
	'propAniDirectionOutBottom': 'Na dno',
	'propAniEntranceTime': 'Započni u (sekunde):',
	'propAniExitTime': 'Završi u (sekunde):',
	'animationNoEntranceText': 'Ulazna animacija se neće izvesti ako se grafički element nalazi na početku scene.',
	'animationNoExitText': 'Izlazna animacija se neće izvesti ako se grafički element nalazi na kraju scene.',
	'propAniTypeDataEntrance': 'Ulaz podataka',
	'propAniRevealDuration': 'Trajanje ulazne animacije',
	'timelineAnimationProperties': 'Otvori svojstva animacije',
	'scenesPropertiesSection': 'Scene',
	'editStoryCoachMarkTitle': 'Uredi priču',
	'editStoryCoachMarkContents': 'Kliknite ikonu olovke i uredite ovu priču.',
	'addDataStoryCoachMarkContents': 'Povucite i ispustite podatke iz panela podataka u priču.',
	'expandSceneCoachmarkTitle': 'Otvori vremensku skalu',
	'expandSceneCoachmarkContents': 'Animirajte scenu prilagođavanjem vidljivosti objekta na temelju vremena i trajanja.',
	'overviewCoachmarkTitle': 'Pregled scena',
	'overviewCoachmarkContents': 'Koristite pregled scena na početku i kraju priče kako bi prikazali sliku svih scena zajedno. Na pregledu scena kliknite i povucite scenu da ju zamijenite s drugom scenom. Možete pokazati ili sakriti pregled scena u svojstvima priče.',
	'animatedPathCoachmarkTitle': 'Animirana staza',
	'animatedPathCoachmarkContents': 'Da biste animirali objekt iz jedne u drugu scenu, duplicirajte scenu s objektom. Zatim, pomaknite, promijenite veličinu ili rotirajte duplicirani objekt na novu scenu.',
	'propShowStoryOverviewFirstSlide': 'Pokaži sve scene na početku',
	'propShowStoryOverviewLastSlide': 'Pokaži sve scene na kraju',
	'storySceneSingleCountLabel': '1 scena',
	'storySceneCountLabel': '%{count} scena',
	'storySceneRangeCountLabel': 'Scena %{index} od %{count}',
	'storySceneExpand': 'Otvori vremensku skalu',
	'storySceneActionMenu': 'Pokreni izbornik opcija scene',
	'timelineRightContainerLabel': 'Grupa gumb kontrola vremenske skale',
	'timelineViewLabel': 'Vremenska skala',
	'timelineZoomFit': 'Zumiraj da stane',
	'timelineZoomIn': 'Povećaj',
	'timelineZoomOut': 'Smanji',
	'timelinePositionIndicator': 'indikator položaja na vremenskoj skali na %{position}',
	'timelinePositionIndicatorMoveLeftTo': 'pomakni indikator položaja na vremenskoj skali lijevo na %{position}',
	'timelinePositionIndicatorMoveRightTo': 'pomakni indikator položaja na vremenskoj skali desno na %{position}',
	'sceneStart': 'Skoči na početak scene na %{position}',
	'sceneEnd': 'Skoči na kraj scene na %{position}',
	'timelineHighlightTitle': 'Isticanje',
	'addTimelineHighlight': 'Dodaj isticanje',
	'addSceneBtnTitle': 'Dodaj novu scenu s defaultnim predloškom',
	'addSceneChevronBtnTitle': 'Izbor predloška scene',
	'timelinePlay': 'Pokreni',
	'timelinePause': 'Pauziraj',
	'sceneNavigation': 'Navigacija scene',
	'navNextScene': 'Sljedeća scena',
	'navPrevScene': 'Prethodna scena',
	'navPrevSceneAbbreviated': 'Prethodna scena',
	'navExitFullScreen': 'Izađi iz prikaza na cijelom zaslonu',
	'navToggleOverview': 'Prebaci pregled',
	'rowNumber': 'Red %{number}',
	'overviewBtnLabel': 'Pregled',
	'sceneListStart': 'Početak pregleda',
	'sceneListEnd': 'Kraj pregleda',
	'timelineLeftHandle': 'lijevi držač za %{name}',
	'timelineRightHandle': 'desni držač za %{name}',
	'timelineLeftHandleNoTitle': 'lijevi držač',
	'timelineRightHandleNoTitle': 'desni držač',
	'timelineMoveLeft': 'Pomakni %{object} lijevo',
	'timelineMoveRight': 'Pomakni %{object} desno',
	'timelineMoveWidget': 'Grafički element vremenske skale pomaknut na %{newStartTime} i %{newEndTime}',
	'timelineMoveWidgetStartTime': 'Početno vrijeme vremenske skale promijenjeno u %{newStartTime}',
	'timelineMoveWidgetEndTime': 'Završno vrijeme vremenske skale promijenjeno u %{newEndTime}',
	'timelineMoveWidgetDown': 'vremenska skala pomaknuta dolje',
	'timelineMoveWidgetUp': 'vremenska skala pomaknuta gore',
	'addSceneTitle': 'Dodavanje scene',
	'blankSceneLayout': 'Prazno',
	'titleSceneLayout': 'Naslov s podnaslovom',
	'sceneLayout1': 'Naslov s tekstom pored jedne vizualizacije',
	'sceneLayout2': 'Naslov s jednom vizualizacijom',
	'sceneLayout3': 'Naslov s dvije vizualizacije',
	'sceneLayout4': 'Višenamjenski',
	'sceneLayout5': 'Bez naslova s tekstom pored jedne vizualizacije',
	'sceneLayout6': 'Višenamjenski 2 puta 2',
	'sceneLayout7': 'Višenamjenski 2 pored 1',
	'sceneLayout8': 'Višenamjenski 1 pored 2',
	'sceneLayout9': 'Višenamjenski 1 preko 2',
	'sceneLayout10': 'Višenamjenski 2 preko 1',
	'sceneLayout11': 'Višenamjenski 2 preko 1',
	'sceneLayout12': 'Višenamjenski 1 preko 1 pored 2 puta 2 preko 1',
	'titleWidgetPlaceholderText': 'Ovdje unesite naslov',
	'subtitleWidgetPlaceholderText': 'Ovdje unesite podnaslov',
	'createStoryViewTitle': 'Kreiraj priču',
	'defaultStoryName': 'Nova priča',
	'screenshot_label': 'Priča %{title}',
	'screenshot_label_scene': 'Scena %{sceneTitle} iz priče %{title}',
	'filmstripHandleOpenLabel': 'Otvori izbornik scene',
	'filmstripHandleCloseLabel': 'Zatvori izbornik scene'
});
